<script setup>
import {BToast} from 'bootstrap-vue-next'
import { defineModel, defineProps, watch,  } from 'vue';

const toast= defineModel()
const props = defineProps({
    text : String,
    success : Boolean,

})


watch(toast, (newVal) => {
    if(newVal){
        setTimeout(() => {
            toast.value = false
        }, 3000);
        
    }
    
    
});

</script>

<template>
    <Teleport to="body">
      <div class="top-0 end-0 toast-container position-fixed p-3">
        <BToast v-model="toast" :class="props.success ? 'bg-success' : 'bg-danger'" :auto-hide="true"
      :delay="3000"
      show-progress>
        
          {{ props.text }}
        </BToast>
      </div>
    </Teleport>
</template>